import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const STORAGE_KEY = "nexus_persona_script_drawer_layout";

interface ScriptDrawerLayoutState {
  isVersionsRailCollapsed: boolean;
  toggleVersionsRail: () => void;
}

export const useScriptDrawerLayoutStore = create<ScriptDrawerLayoutState>()(
  persist(
    (set) => ({
      isVersionsRailCollapsed: false,
      toggleVersionsRail: () =>
        set((state) => ({ isVersionsRailCollapsed: !state.isVersionsRailCollapsed })),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ isVersionsRailCollapsed: state.isVersionsRailCollapsed }),
    },
  ),
);
